import cn from 'classnames';
import React from 'react';
import { ReactNode } from 'react';

import styles from './tag-wrapper.module.scss';

export const TagWrapper: React.FC<{
  label: string;
  light?: boolean;
  children: ReactNode;
}> = ({ label, light, children }) => {
  return (
    <div
      className={cn(styles.tagWrapper, {
        [styles.tagWrapperLight as string]: light,
      })}
    >
      <span className={styles.tagName}>{label}</span>
      {children}
    </div>
  );
};
